import { render, staticRenderFns } from "./EmailProviderError.vue?vue&type=template&id=1fee9bf4&scoped=true&"
import script from "./EmailProviderError.vue?vue&type=script&lang=js&"
export * from "./EmailProviderError.vue?vue&type=script&lang=js&"
import style0 from "./EmailProviderError.vue?vue&type=style&index=0&id=1fee9bf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fee9bf4",
  null
  
)

export default component.exports